import { render, staticRenderFns } from "./RoleAuthorizeRecordTable.vue?vue&type=template&id=bdfc7e10&scoped=true&"
import script from "./RoleAuthorizeRecordTable.vue?vue&type=script&lang=js&"
export * from "./RoleAuthorizeRecordTable.vue?vue&type=script&lang=js&"
import style0 from "./RoleAuthorizeRecordTable.vue?vue&type=style&index=0&id=bdfc7e10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdfc7e10",
  null
  
)

export default component.exports